<template>
    <page :empty="!articles.length > 0">
        <template slot="header">
            <h1>Aktuelles</h1>
        </template>
        <articles :articles="articles"></articles>
    </page>
</template>

<script type="text/babel">
import articles from './Articles/Listing.vue';
import page from './Page.vue';

export default {
  data() {
    return {};
  },
  components: {
    articles,
    page,
  },
  computed: {
    articles() {
      return this.$store.getters.getNews;
    },
  },
};
</script>

<style lang="scss">
</style>
